import React from 'react'
import * as El from '../Grid/Container'

const Agb = ({ data }) => {
  const html = data.content.childMarkdownRemark.html
  return <El.Container dangerouslySetInnerHTML={{ __html: html }} />
}

export default Agb
